
// -----------------------------------------------------------------------------
// 📌 App.tsx — Full Project Routing
// Cleaned + Organized + Fully Commented
// -----------------------------------------------------------------------------

import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// -----------------------------------------------------------------------------
// 🌐 PUBLIC COMPONENTS
// -----------------------------------------------------------------------------

import Home from "./Main_Components/Header/Home/home";
// import { Footer } from "./Main_Components/Footer/footer";

// -----------------------------------------------------------------------------
// 🔥 FIREBASE GLOBAL STATE
// -----------------------------------------------------------------------------

import MyState from "./Backend/Firebase/data/myState";

// -----------------------------------------------------------------------------
// 🧑‍💼 ADMIN DASHBOARD
// -----------------------------------------------------------------------------

import Dashboard from "./Admin_Panel/Dashboard/dashboard/dashboard";

// -----------------------------------------------------------------------------
// 📚 PUBLIC E-LIBRARY
// -----------------------------------------------------------------------------

import LibraryListPage from "./Additional_components/Additional/Elibrary/elibrary";

// -----------------------------------------------------------------------------
// 📚 NEW MULTI-LEVEL E-LIBRARY SYSTEM
// Library → Book → Chapter
// -----------------------------------------------------------------------------

import CreateLibrary from "./Admin_Panel/Dashboard/createLibrary/createLibrary";
import CreateBookPage from "./Admin_Panel/Dashboard/createBook/createBook";
import CreateChapter from "./Admin_Panel/Dashboard/createChapter/createChapter";

// -----------------------------------------------------------------------------
// ✏️ NEW E-LIBRARY UPDATE SYSTEM
// -----------------------------------------------------------------------------

import UpdateLibraryPage from "./Admin_Panel/Dashboard/Update/updateLibrary";
import UpdateBookPage from "./Admin_Panel/Dashboard/Update/Updatebook";
import UpdateChapterPage from "./Admin_Panel/Dashboard/Update/UpdateBlog";

// -----------------------------------------------------------------------------
// 📰 OLD BLOG / CHAPTER MANAGEMENT
// -----------------------------------------------------------------------------

import Createnew from "./Admin_Panel/Dashboard/Update/AddNewChapter";

// -----------------------------------------------------------------------------
// 📚 OLD E-LIBRARY SYSTEM (LEGACY)
// -----------------------------------------------------------------------------

import Elibrary from "./Admin_Panel/Dashboard/E-Library/e-library";
import AddElibraryPage from "./Admin_Panel/Dashboard/E-Library/Create/AddPage";
import EditLibrary from "./Admin_Panel/Dashboard/E-Library/Update/EditLibrary";
import LibraryList from "./Admin_Panel/Dashboard/E-Library/Update/LibraryList";
import SubtopicForm from "./Admin_Panel/Dashboard/E-Library/Update/SubtopicForm";
import EditSubtopic from "./Admin_Panel/Dashboard/E-Library/Update/UpdatePage";

// -----------------------------------------------------------------------------
// 🏆 CERTIFICATE MANAGEMENT
// -----------------------------------------------------------------------------

import Mainpage_certificate from "./Admin_Panel/Dashboard/GenerateCertificate/mainpage_certificate";

import GenerateAzureCertificate from "./Admin_Panel/Dashboard/GenerateCertificate/Azure-Certificate/GenerateAzureCertificate";

import GeneratePythonCertificate from "./Admin_Panel/Dashboard/GenerateCertificate/Python-Certificate/GeneratePythonCertificate";

import GenerateSQLCertificate from "./Admin_Panel/Dashboard/GenerateCertificate/SQL-Certificate/GenerateSQLCertificate";

import Certificatedata from "./Admin_Panel/Dashboard/GenerateCertificate/Cerificate-Data/Certificate-data";

import VerificationForm from "./Admin_Panel/Dashboard/GenerateCertificate/Verification/Verify";

// -----------------------------------------------------------------------------
// 🏡 HOMEPAGE SETTINGS & CONTENT UPDATE
// -----------------------------------------------------------------------------

import UpdatePosterImg from "./Admin_Panel/Dashboard/EditHomepage/UpdatePosterImg/updateposterimg";

import Updatedates from "./Admin_Panel/Dashboard/EditHomepage/UpdateDate/Update-Dates";

import UpdateGif from "./Admin_Panel/Dashboard/EditHomepage/UpdateGif/Update-Gif";

import UpdateValuesTable from "./Admin_Panel/Dashboard/EditHomepage/UpdateHike/Update-Value";

import Updatetestinomials from "./Admin_Panel/Dashboard/EditHomepage/UpdateTestimonials/updatetestinomials";

import Mainpage_home from "./Admin_Panel/Dashboard/EditHomepage/mainpage_home";

// -----------------------------------------------------------------------------
// 📄 FORM DATA VIEWS
// -----------------------------------------------------------------------------

import ViewFormData from "./Admin_Panel/Dashboard/ViewFormsData/ViewFormData";

import ViewHireFormUS from "./Admin_Panel/Dashboard/ViewFormsData/View-HireFromUS/ViewHirefromUS";

import ViewCorporateData from "./Admin_Panel/Dashboard/ViewFormsData/View-CorporateTrainig/ViewCorporateTraining";

// -----------------------------------------------------------------------------
// 💼 LATEST JOBS
// -----------------------------------------------------------------------------

import Latestjob from "./Admin_Panel/Dashboard/Latest-Job/Latestjob";

// -----------------------------------------------------------------------------
// 🚀 APPLICATION ROOT
// -----------------------------------------------------------------------------

function App() {
  return (
    <MyState>

      {/* ================================================================ */}
      {/* 🌐 ROUTING START                                                 */}
      {/* ================================================================ */}

      <Routes>

        {/* ================================================================ */}
        {/* 🏠 PUBLIC ROUTES                                                */}
        {/* ================================================================ */}

        <Route
          path="/"
          element={<Home />}
        />

        <Route
          path="/elibrayshow"
          element={<LibraryListPage />}
        />

        <Route
          path="/certificate-validation"
          element={<VerificationForm />}
        />

        {/* ================================================================ */}
        {/* 🧑‍💼 ADMIN DASHBOARD                                            */}
        {/* ================================================================ */}

        <Route
          path="/dashboard"
          element={<Dashboard />}
        />

        {/* ================================================================ */}
        {/* 📚 NEW GENERATION E-LIBRARY                                     */}
        {/*                                                                  */}
        {/* Structure:                                                       */}
        {/* Library → Book → Chapter                                         */}
        {/* ================================================================ */}

        {/* -------------------------------------------------------------- */}
        {/* 1️⃣ CREATE LIBRARY                                              */}
        {/* -------------------------------------------------------------- */}

        <Route
          path="/createLibrary"
          element={<CreateLibrary />}
        />

        {/* -------------------------------------------------------------- */}
        {/* 2️⃣ CREATE BOOK                                                 */}
        {/* -------------------------------------------------------------- */}

        <Route
          path="/createLibrary/:librarySlug/create-book"
          element={<CreateBookPage />}
        />

        {/* -------------------------------------------------------------- */}
        {/* 3️⃣ CREATE CHAPTER                                              */}
        {/* CKEditor is used inside CreateChapter                           */}
        {/* -------------------------------------------------------------- */}

        <Route
          path="/createLibrary/:librarySlug/create-book/:bookSlug/create-chapter"
          element={<CreateChapter />}
        />

        {/* ================================================================ */}
        {/* ✏️ UPDATE NEW E-LIBRARY                                         */}
        {/* ================================================================ */}

        {/* -------------------------------------------------------------- */}
        {/* UPDATE LIBRARY                                                  */}
        {/* -------------------------------------------------------------- */}

        <Route
          path="/update/:librarySlug"
          element={<UpdateLibraryPage />}
        />

        {/* -------------------------------------------------------------- */}
        {/* UPDATE BOOK                                                     */}
        {/* -------------------------------------------------------------- */}

        <Route
          path="/updatebook/:librarySlug/:bookSlug"
          element={<UpdateBookPage />}
        />

        {/* -------------------------------------------------------------- */}
        {/* UPDATE CHAPTER                                                  */}
        {/* CKEditor is used inside UpdateChapterPage                       */}
        {/* -------------------------------------------------------------- */}

        <Route
          path="/updatechapter/:librarySlug/:bookSlug/:chapterSlug"
          element={<UpdateChapterPage />}
        />

        {/* ================================================================ */}
        {/* 📰 OLD BLOG / CHAPTER ROUTE                                     */}
        {/* ================================================================ */}

        <Route
          path="/createnew/:id"
          element={<Createnew />}
        />

        {/* ================================================================ */}
        {/* 📚 OLD LEGACY E-LIBRARY SYSTEM                                  */}
        {/* ================================================================ */}

        <Route
          path="/elibrary"
          element={<Elibrary />}
        />

        <Route
          path="/elibrary/create"
          element={<AddElibraryPage />}
        />

        <Route
          path="/elibrary/update"
          element={<LibraryList />}
        />

        <Route
          path="/elibrary/update/:id"
          element={<EditLibrary />}
        />

        <Route
          path="/elibrary/:id/subtopic/new"
          element={<SubtopicForm />}
        />

        <Route
          path="/elibrary/:id/subtopic/:subId/edit"
          element={<EditSubtopic />}
        />

        {/* ================================================================ */}
        {/* 🏆 CERTIFICATE MANAGEMENT                                       */}
        {/* ================================================================ */}

        <Route
          path="/generate-certificate"
          element={<Mainpage_certificate />}
        />

        <Route
          path="/generate-certificate/certificate-data"
          element={<Certificatedata />}
        />

        <Route
          path="/generate-certificate/Azure"
          element={<GenerateAzureCertificate />}
        />

        <Route
          path="/generate-certificate/Python"
          element={<GeneratePythonCertificate />}
        />

        <Route
          path="/generate-certificate/SQL"
          element={<GenerateSQLCertificate />}
        />

        {/* ================================================================ */}
        {/* 🏡 HOMEPAGE CONTENT MANAGEMENT                                  */}
        {/* ================================================================ */}

        <Route
          path="/edit-dates"
          element={<Updatedates />}
        />

        <Route
          path="/update-ocassion"
          element={<UpdateGif />}
        />

        <Route
          path="/edit-values"
          element={<UpdateValuesTable />}
        />

        <Route
          path="/edit-testinomials"
          element={<Updatetestinomials />}
        />

        <Route
          path="/edithomepage"
          element={<Mainpage_home />}
        />

        <Route
          path="/edit-poster"
          element={<UpdatePosterImg />}
        />

        {/* ================================================================ */}
        {/* 🧾 FORM DATA VIEWS                                              */}
        {/* ================================================================ */}

        <Route
          path="/dashboard/Admin-Pannel/View-Form-Data"
          element={<ViewFormData />}
        />

        <Route
          path="/View-Form-Data/View-Hire-From-US"
          element={<ViewHireFormUS />}
        />

        <Route
          path="/View-Form-Data/View-Corporate-Training"
          element={<ViewCorporateData />}
        />

        {/* ================================================================ */}
        {/* 💼 LATEST JOBS                                                  */}
        {/* ================================================================ */}

        <Route
          path="/latestjob"
          element={<Latestjob />}
        />

      </Routes>

      {/* ================================================================ */}
      {/* 🔔 GLOBAL TOAST NOTIFICATIONS                                    */}
      {/* ================================================================ */}

      <Toaster />

      {/* ================================================================ */}
      {/* 🌐 GLOBAL FOOTER                                                 */}
      {/* ================================================================ */}

      {/* <Footer /> */}

    </MyState>
  );
}

export default App;

